import { RouteRecordRaw } from 'vue-router';
import { route } from '@/router/utils'
// import { allPermissions } from '@access/index'
// import { accessPermission } from '@/permissions/permissions'

// const {
//   STAFF: {
//     USER: {
//       VIEW
//     },
//   },
// } = allPermissions

const details = () => import('./Details.vue')

export const ANALYTICS_DETAILS_PAGE_NAME = 'cabinet:analytics'

// URLs

export const ANALYTICS_DETAILS_PAGE_URL = ''

export function createRoutes(options): RouteRecordRaw[] {
  return [
    route(ANALYTICS_DETAILS_PAGE_URL, details, ANALYTICS_DETAILS_PAGE_NAME, {
      meta: {
        breadcrumb: 'analytics-details',
        // ...accessPermission([VIEW], options),
      }
    }),
  ]
}
